<div class="synergies">
  <!-- Actions Bar -->
  <div class="synergies__actions-bar">
    <!-- Search -->
    <div class="synergies__search">
      <i class="pi pi-search"></i>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        placeholder="Synergie suchen..."
      />
    </div>

    <!-- Filter Chips -->
    <div class="synergies__chips">
      <button
        class="synergies__chip"
        [class.synergies__chip--active]="!selectedType && !selectedStatus"
        (click)="clearFilters()">
        Alle
      </button>
      <button
        class="synergies__chip"
        [class.synergies__chip--active]="selectedType === 'internal'"
        (click)="setTypeFilter('internal')">
        Intern
      </button>
      <button
        class="synergies__chip"
        [class.synergies__chip--active]="selectedType === 'external'"
        (click)="setTypeFilter('external')">
        Extern
      </button>
      <button
        class="synergies__chip"
        [class.synergies__chip--active]="selectedStatus === 'active'"
        (click)="setStatusFilter('active')">
        Aktiv
      </button>
      <button
        class="synergies__chip"
        [class.synergies__chip--active]="selectedStatus === 'pending'"
        (click)="setStatusFilter('pending')">
        Wartend
      </button>
    </div>

    <!-- Count -->
    <div class="synergies__count">{{ filteredSynergies.length }} Synergien</div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="synergies__loading">
    <i class="pi pi-spin pi-spinner"></i>
    <p>Synergien werden geladen...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && filteredSynergies.length === 0" class="synergies__empty">
    <div class="synergies__empty-icon">
      <i class="pi pi-users"></i>
    </div>
    <p class="synergies__empty-title">Keine Synergien gefunden</p>
    <span class="synergies__empty-text">Versuche andere Filter oder Suchbegriffe</span>
  </div>

  <!-- Card Grid -->
  <div *ngIf="!isLoading && filteredSynergies.length > 0" class="synergies__grid">
    <div
      *ngFor="let synergy of filteredSynergies"
      class="synergy-card"
      (click)="openDetail(synergy)">

      <!-- Image Area with Avatars -->
      <div class="synergy-card__image">
        <div class="synergy-card__avatars">
          <div class="synergy-card__avatar">
            <img *ngIf="synergy.hub_1.avatar" [src]="synergy.hub_1.avatar" [alt]="synergy.hub_1.name" />
            <div *ngIf="!synergy.hub_1.avatar" class="synergy-card__placeholder">
              <i class="pi pi-building"></i>
            </div>
          </div>
          <div class="synergy-card__avatar synergy-card__avatar--second">
            <img *ngIf="synergy.hub_2.avatar" [src]="synergy.hub_2.avatar" [alt]="synergy.hub_2.name" />
            <div *ngIf="!synergy.hub_2.avatar" class="synergy-card__placeholder">
              <i class="pi pi-building"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="synergy-card__content">
        <div class="synergy-card__title">{{ synergy.hub_1.name }} & {{ synergy.hub_2.name }}</div>
        <div class="synergy-card__meta">{{ getCategoryLabel(synergy.category) }} · {{ synergy.hub_1.city }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Detail Sheet -->
<app-synergy-detail-sheet
  [synergy]="selectedSynergy"
  [isOpen]="sheetVisible"
  [isDesktop]="isDesktop"
  (close)="closeDetail()">
</app-synergy-detail-sheet>

<p-toast />